<template>
  <v-dialog
    id="ApproachFlowDialog"
    scrollable
    persistent
    :max-width="
      ['CALL', 'CALL_PHONE', 'CALL_CELLPHONE', 'EMAIL', 'WHATSAPP'].includes(
        currentRuleType,
      )
        ? '65vw'
        : '80vw'
    "
    :max-height="
      ['CALL', 'CALL_PHONE', 'CALL_CELLPHONE'].includes(currentRuleType)
        ? '60vh'
        : ''
    "
    v-model="dialogModel"
    :fullscreen="$vuetify.breakpoint.smAndDown"
  >
    <template v-slot:activator="{ on }">
      <v-layout justify-center align-center>
        <v-speed-dial
          fixed
          v-model="fabModel"
          bottom
          :right="$vuetify.breakpoint.mdAndUp"
          transition="scale-transition"
          :direction="$vuetify.breakpoint.mdAndUp ? 'left' : 'top'"
        >
          <template v-slot:activator>
            <v-btn v-model="fabModel" color="primary" dark fab>
              <v-icon>add</v-icon>
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <v-btn
            class="text-xs-left"
            v-for="(tab, key) in addButtons"
            :key="key"
            dark
            round
            :color="tab.color"
            v-on="on"
            @click="$emit('update:currentRuleType', tab.value)"
            style
            >{{ tab.name }}</v-btn
          >
          <v-layout justify-end wrap></v-layout>
        </v-speed-dial>
      </v-layout>
    </template>
    <v-card>
      <v-card-title>
        <span class="headline">{{ approachFlow.name }}</span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0">
        <v-layout wrap>
          <v-flex xs12 class="mb-3">
            <div class="subheading font-weight-bold grey--text text--darken-4 mb-2">
              Agendamento
            </div>
            <v-layout row wrap>
              <v-flex xs12 sm3 md2 class="pr-2">
                <v-text-field
                  box
                  hide-details
                  label="Dia"
                  type="number"
                  min="1"
                  prepend-inner-icon="mdi-calendar-today"
                  :error="hasFailure"
                  v-model="currentFlowRule.offset"
                  @input="$emit('update:failureText', '')"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-select
                  box
                  hide-details
                  label="Horário"
                  item-text="text"
                  item-value="value"
                  prepend-inner-icon="mdi-clock-outline"
                  :items="timeOptions"
                  :error="hasFailure"
                  v-model="currentFlowRule.time"
                  @input="$emit('update:failureText', '')"
                ></v-select>
              </v-flex>
            </v-layout>
            <div v-if="hasFailure" class="caption red--text mt-1">
              {{ failureText }}
            </div>
          </v-flex>

          <!--SMS-->
          <v-flex xs12 v-if="currentRuleType == 'SMS_FLASH'">
            <v-alert v-model="alertModel" dismissible type="warning">
              Abordagens do tipo sms_flash não abrem links.
            </v-alert>
          </v-flex>
          <v-flex
            xs12
            v-if="currentRuleType == 'SMS' || currentRuleType == 'SMS_FLASH'"
          >
            <textAreaAutocomplete
              name="sms"
              label="Conteúdo do sms"
              :message="message"
              :variables="variables"
              @message="$emit('update:message', $event)"
            />
            <small>
              <div class="text-xs-right" style="padding: 4px">
                <strong>{{ contentLength + "/160 caracteres" }}</strong>
              </div>
            </small>
          </v-flex>

          <!--PUSH-->
          <v-flex xs12 class="mb-3" v-if="currentRuleType == 'PUSH'">
            <v-text-field
              box
              required
              hide-details
              class="green-input"
              v-model="push.title"
              value="Novo push"
              label="Título*"
              name="push_title"
            />
          </v-flex>
          <v-flex xs12 class="mb-3" v-if="currentRuleType == 'PUSH'">
            <v-select
              box
              required
              hide-details
              label="Link*"
              :items="links"
              v-model="push.link"
            ></v-select>
          </v-flex>
          <v-flex xs12 class="mb-3" v-if="currentRuleType == 'PUSH'">
            <textAreaAutocomplete
              name="body"
              label="Conteúdo do push"
              :message="push.body"
              :variables="variables"
              @message="push.body = $event"
            />
          </v-flex>

          <!--EMAIL-->
          <v-flex
            xs12
            class="mb-3"
            v-if="currentRuleType == 'EMAIL' || currentRuleType == 'EMAIL_TEXT'"
          >
            <v-text-field
              box
              required
              hide-details
              name="email_subject"
              label="Assunto do email *"
              v-model="email.subject"
            />
          </v-flex>
          <v-flex
            xs12
            class="mb-3"
            v-if="currentRuleType == 'EMAIL' || currentRuleType == 'EMAIL_TEXT'"
          >
            <v-text-field
              box
              required
              hide-details
              type="url"
              size="100"
              name="url_email"
              label="Url do asset"
              v-model="email.url"
            >
              <template v-slot:append>
                <v-icon
                  color="primary"
                  :disabled="!isValidHttpUrl(email.url)"
                  @click="window.open(`${email.url}`, '_blank')"
                  >mdi-code-tags</v-icon
                >
              </template>
            </v-text-field>
          </v-flex>

          <!--LIGAÇÃO-->
          <v-flex
            xs12
            class="mb-3"
            v-if="
              ['CALL', 'CALL_CELLPHONE', 'CALL_PHONE'].includes(currentRuleType)
            "
          >
            <v-select
              hide-details
              :items="[
                { type: 'CALL_PHONE', label: 'Fixo' },
                { type: 'CALL_CELLPHONE', label: 'Celular' },
              ]"
              label="Tipo da ligação"
              v-model="call.type"
              item-text="label"
              item-value="type"
            ></v-select>
          </v-flex>
          <v-flex
            xs12
            class="mb-3"
            v-if="
              ['CALL', 'CALL_CELLPHONE', 'CALL_PHONE'].includes(currentRuleType)
            "
          >
            <v-select
              :items="callCampaigns"
              label="Campanha da Ura"
              v-model="call.campaign"
              item-text="name"
              item-value="id"
            ></v-select>
          </v-flex>

          <!--WHATSAPP-->
          <v-flex xs12 class="mb-3" v-if="currentRuleType == 'WHATSAPP'">
            <div class="subheading font-weight-bold grey--text text--darken-4 mb-2">
              Iniciativa principal
            </div>
            <initiative-selector
              :value="initiativeId"
              @input="$emit('update:initiativeId', $event)"
              :creditor-id="approachFlow.creditor_id"
              :exclude-ids="primaryExcludeIds"
              initial-category="UTILITY"
              scope="FIRING"
            >
              <template v-slot:activator="{ initiative, open, editUrl, loading }">
                <v-flex>
                  <initiative-flow-card
                    :initiative="initiative"
                    :loading="loading"
                    :edit-url="editUrl"
                    highlighted
                    editable
                    @select="open"
                  />
                </v-flex>
              </template>
            </initiative-selector>

            <template v-if="hasFallbackItems">
              <div class="subheading font-weight-bold grey--text text--darken-4 mt-4 mb-2">
                {{ fallbackTitle }}
              </div>
              <draggable v-model="localFallbackItems" handle=".drag-handle" @change="onFallbackReorder">
                <initiative-selector
                  v-for="(item, idx) in localFallbackItems"
                  :key="item.key"
                  ref="fallbackSelectors"
                  :class="{ 'mb-2': !!item.id }"
                  :value="item.id"
                  :disabled="!initiativeId || !!item.id"
                  :restrict-owner="primaryBroker"
                  :restrict-creditor-id="primaryCreditorId"
                  :exclude-ids="fallbackExcludeIds(idx)"
                  :creditor-id="approachFlow.creditor_id"
                  initial-category="UTILITY"
                  scope="FIRING"
                  @input="updateFallbackAt(idx, $event)"
                  @cancel="discardEmptyFallbackAt(idx)"
                >
                  <template v-slot:activator="{ initiative, open, disabled, loading }">
                    <v-flex v-show="item.id">
                      <initiative-flow-card
                        :initiative="initiative"
                        :loading="loading"
                        :disabled="disabled"
                        show-drag-handle
                        removable
                        @select="open"
                        @remove="removeFallbackAt(idx)"
                      />
                    </v-flex>
                  </template>
                </initiative-selector>
              </draggable>
            </template>

            <v-btn
              v-if="canAddFallback"
              block
              flat
              color="primary"
              class="mx-0 mt-2 text-none add-fallback-btn"
              :disabled="!initiativeId"
              @click="enableFallback"
            >
              <v-icon left>add</v-icon>
              Adicionar iniciativa de reserva
            </v-btn>
          </v-flex>

          <!--EMAIL_TEXT-->
          <v-flex xs12 class="mb-3" v-if="currentRuleType == 'EMAIL_TEXT'">
            <vue-mce
              ref="tynyMce"
              v-model="email.content"
              :config="configMce"
            />
          </v-flex>

          <!--VARIABLES-->
          <v-flex
            v-if="
              ![
                'CALL',
                'CALL_CELLPHONE',
                'CALL_PHONE',
                'EMAIL',
                'WHATSAPP',
              ].includes(currentRuleType)
            "
          >
            <v-flex>
              <v-switch
                hide-details
                class="mb-1 mt-0 pt-0"
                label="Mostrar mais variáveis"
                v-model="switchShowModel"
              >
              </v-switch>
            </v-flex>

            <v-flex
              md12
              class="mb-3"
              style="overflow: auto; border: 1px solid #cccccc"
            >
              <v-layout
                wrap
                align-left
                justify-left
                class="var-container"
                :data-select="variableSelected"
              >
                <v-flex
                  lg3
                  md4
                  sm6
                  xs12
                  :key="`${k}`"
                  v-for="(variable, k) in variables"
                  v-show="switchShow ? true : variable.show"
                >
                  <v-chip
                    class="var-content"
                    :disabled="variable.selected"
                    @click="$emit('var-click', variable.name)"
                  >
                    <small>
                      <strong>{{ variable.name }}</strong>
                      <br />
                      <small style="margin-top: -2px; font-size: 10px">
                        {{ variable.label }}
                      </small>
                    </small>
                  </v-chip>
                </v-flex>
              </v-layout>
            </v-flex>
            <!--VARIABLES-->
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-layout class="pa-2" row wrap>
          <v-select
            box
            clearable
            hide-details
            item-value="id"
            label="Tipo da oferta"
            item-text="description"
            :items="offerTypes"
            v-model="currentFlowRule.offer_type_id"
          ></v-select>
          <v-spacer></v-spacer>
          <v-btn
            v-if="currentRuleType == 'WHATSAPP'"
            class="ml-2"
            color="blue lighten-1"
            outline
            style="margin-top: 6px"
            @click="$emit('update:previewWppDialog', true)"
            :disabled="!initiativeId || loadingPreview"
          >
            Visualizar
          </v-btn>
          <v-btn
            outline
            color="primary"
            style="margin-top: 6px"
            @click="dialogModel = false"
          >
            Fechar
          </v-btn>
          <v-btn
            x-large
            color="primary"
            class="elevation-0"
            style="margin-top: 6px"
            :disabled="!contentValid"
            @click="$emit('save-data')"
          >
            Salvar
          </v-btn>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import textAreaAutocomplete from '@/components/TextAreaAutocomplete';
import InitiativeSelector from "@/components/selects/InitiativeSelector.vue";
import InitiativeFlowCard from "../InitiativeFlowCard.vue";
import draggable from "vuedraggable";

const MAX_FALLBACK_INITIATIVES = 4;

export default {
  name: 'DialogApproachFlowEdit',
  components: { textAreaAutocomplete, InitiativeSelector, InitiativeFlowCard, draggable },
  data() {
    return {
      MAX_FALLBACK_INITIATIVES,
      // espelha fallbackInitiativeIds: vuedraggable exige um array reativo real (não um computed) para funcionar
      localFallbackItems: [],
      nextFallbackKey: 0,
    };
  },
  props: {
    dialog: { type: Boolean, default: false },
    fab: { type: Boolean, default: false },
    loadingPreview: { type: Boolean, default: false },
    currentRuleType: { type: String, default: null },
    addButtons: { type: Array, default: () => [] },
    approachFlow: { type: Object, default: () => ({}) },
    currentFlowRule: { type: Object, default: () => ({}) },
    failureText: { type: String, default: '' },
    allowedTimes: { type: Array, default: () => [] },
    allowedTimesEmail: { type: Array, default: () => [] },
    message: { type: String, default: '' },
    variables: { type: Array, default: () => [] },
    contentLength: { type: Number, default: 0 },
    alert: { type: Boolean, default: true },
    push: { type: Object, default: () => ({}) },
    links: { type: Array, default: () => [] },
    email: { type: Object, default: () => ({}) },
    call: { type: Object, default: () => ({}) },
    callCampaigns: { type: Array, default: () => [] },
    initiativeId: { default: null },
    initiativeObj: { default: null },
    fallbackEnabled: { type: Boolean, default: false },
    fallbackInitiativeIds: { type: Array, default: () => [] },
    primaryBroker: { type: String, default: null },
    primaryCreditorId: { type: [Number, String], default: null },
    configMce: { type: Object, default: () => ({}) },
    switchShow: { type: Boolean, default: false },
    variableSelected: { default: false },
    offerTypes: { type: Array, default: () => [] },
    previewWppDialog: { type: Boolean, default: false },
    contentValid: { type: Boolean, default: false },
  },
  computed: {
    dialogModel: {
      get() { return this.dialog; },
      set(val) { this.$emit('update:dialog', val); },
    },
    fabModel: {
      get() { return this.fab; },
      set(val) { this.$emit('update:fab', val); },
    },
    alertModel: {
      get() { return this.alert; },
      set(val) { this.$emit('update:alert', val); },
    },
    switchShowModel: {
      get() { return this.switchShow; },
      set(val) { this.$emit('update:switchShow', val); },
    },
    fallbackEnabledModel: {
      get() { return this.fallbackEnabled; },
      set(val) { this.$emit('update:fallbackEnabled', val); },
    },
    fallbackInitiativeIdsModel: {
      get() { return this.fallbackInitiativeIds; },
      set(val) { this.$emit('update:fallbackInitiativeIds', val); },
    },
    primaryExcludeIds() {
      return this.localFallbackItems.map((item) => item.id).filter((id) => !!id);
    },
    canAddFallback() {
      return this.fallbackInitiativeIdsModel.length < MAX_FALLBACK_INITIATIVES;
    },
    hasFallbackItems() {
      return this.fallbackEnabledModel && this.localFallbackItems.length > 0;
    },
    isEmailRule() {
      return ['EMAIL', 'EMAIL_TEXT'].includes(this.currentRuleType);
    },
    timeOptions() {
      if (this.isEmailRule) return this.allowedTimesEmail;
      return this.allowedTimes;
    },
    hasFailure() {
      return this.failureText.length > 0;
    },
    fallbackTitle() {
      return `Iniciativas alternativas (${this.localFallbackItems.length})`;
    },
  },
  watch: {
    fallbackInitiativeIds: {
      immediate: true,
      handler(newIds) {
        this.localFallbackItems = newIds.map((id, idx) => {
          const existing = this.localFallbackItems[idx];
          return {
            key: existing ? existing.key : this.nextFallbackKey++,
            id,
          };
        });
      },
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleEscKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleEscKeydown);
  },
  methods: {
    handleEscKeydown(event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      if (!this.dialogModel) return;
      if (this.previewWppDialog) return;
      if (event.defaultPrevented) return;
      this.dialogModel = false;
    },
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === 'http:' || url.protocol === 'https:';
    },
    enableFallback() {
      this.fallbackEnabledModel = true;
      this.addFallback();
      this.$nextTick(() => {
        const selectors = this.$refs.fallbackSelectors;
        const lastSelector = Array.isArray(selectors)
          ? selectors[selectors.length - 1]
          : selectors;
        if (lastSelector) lastSelector.openDialog();
      });
    },
    addFallback() {
      if (this.fallbackInitiativeIdsModel.length >= MAX_FALLBACK_INITIATIVES) return;
      this.fallbackInitiativeIdsModel = [...this.fallbackInitiativeIdsModel, null];
    },
    removeFallbackAt(idx) {
      const updated = this.fallbackInitiativeIdsModel.filter((_, i) => i !== idx);
      this.fallbackInitiativeIdsModel = updated;
      if (!updated.length) this.fallbackEnabledModel = false;
    },
    discardEmptyFallbackAt(idx) {
      if (this.fallbackInitiativeIdsModel[idx]) return;
      this.removeFallbackAt(idx);
    },
    updateFallbackAt(idx, value) {
      const updated = [...this.fallbackInitiativeIdsModel];
      updated[idx] = value;
      this.fallbackInitiativeIdsModel = updated;
    },
    onFallbackReorder() {
      this.fallbackInitiativeIdsModel = this.localFallbackItems.map((item) => item.id);
    },
    fallbackExcludeIds(idx) {
      const otherIds = this.localFallbackItems
        .filter((_, i) => i !== idx)
        .map((item) => item.id);
      return [this.initiativeId, ...otherIds].filter((id) => !!id);
    },
  },
};
</script>

<style scoped>
.var-content {
  border-radius: 12px;
  padding: 2px 0px;
}

.add-fallback-btn {
  border: 1px dashed currentColor;
  border-radius: 8px;
  justify-content: center;
}

.add-fallback-btn >>> .v-btn__content {
  justify-content: flex-start;
}

.var-container {
  max-height: 600px;
  overflow: auto;
}
</style>
